import React from 'react';

import useQaList from '../hooks/useQalist';
import QaCard from '../QaCard';

const QaList = () => {
  const { qaList } = useQaList();

  return (
    <div className="mt-20 flex w-full flex-col space-y-20 px-5 lg:mx-auto lg:mt-[100px] lg:w-[984px] lg:space-y-[100px] lg:px-0 xl:mt-[140px] xl:w-[1400px] xl:space-y-[140px]">
      {qaList.map((item) => (
        <QaCard
          key={item.title}
          imageUrl={item.imageUrl}
          imagePosition={item.imagePosition}
          faqItems={item.faqItems}
          title={item.title}
        />
      ))}
    </div>
  );
};

export default QaList;
